export default {
  items: [
    "Antarctica",
    "Australia (includes External Territories)",
    "Caribbean",
    "Central America",
    "Central and West Africa",
    "Central Asia",
    "Chinese Asia (includes Mongolia)",
    "Eastern Europe",
    "Japan and the Koreas",
    "Mainland South-East Asia",
    "Maritime South-East Asia",
    "Melanesia",
    "Micronesia",
    "Middle East",
    "North Africa",
    "Northern America",
    "Northern Europe",
    "Polynesia (excludes Hawaii)",
    "South America",
    "South Eastern Europe",
    "Southern and East Africa",
    "Southern Asia",
    "Southern Europe",
    "United Kingdom, Channel Islands and Isle of Man",
    "Western Europe"
  ]
}



// WEBPACK FOOTER //
// ../data/wa/minorgroups.js